import React from 'react';
import useLinkStripeAccount from './useLinkStripeAccount';
import useLoginStripeAccount from './useLoginStripeAccount';
import { openExternalUrl } from '../../utils/global/helper';
import { LinkStripeAccountDto } from '../../types/stripe';

const useStripeAccountActions = ({
  refreshUrl,
  returnUrl,
}: Partial<LinkStripeAccountDto> = {}) => {
  const { mutateAsync: linkAccount, isPending: isLinking } =
    useLinkStripeAccount();
  const { mutateAsync: loginAccount, isPending: isGettingLogin } =
    useLoginStripeAccount();

  const openUrl = React.useCallback((url: string) => {
    openExternalUrl(url);
  }, []);

  const onStartSetup = React.useCallback(async () => {
    try {
      if (isLinking || isGettingLogin) return;
      const currentUrl = window.location.href;
      const response = await linkAccount({
        refreshUrl: refreshUrl || currentUrl,
        returnUrl: returnUrl || currentUrl,
      });
      if (!response) return;

      const { url } = response;

      openUrl(url);
    } catch (error) {
      // Do nothing
    }
  }, [isLinking, isGettingLogin, linkAccount, refreshUrl, returnUrl, openUrl]);

  const onViewStripeAccount = React.useCallback(async () => {
    try {
      if (isLinking || isGettingLogin) return;
      const response = await loginAccount();
      if (!response) return;

      const { url } = response;

      openUrl(url);
    } catch (error) {
      // Do nothing
    }
  }, [isLinking, isGettingLogin, loginAccount, openUrl]);

  return {
    isLinking,
    isGettingLogin,
    onStartSetup,
    onViewStripeAccount,
  };
};

export default useStripeAccountActions;
